import React, {
  useEffect,
  useState
} from "react";
import { NavLink } from "react-router-dom";
import {
  FiBarChart,
  FiHome,
  FiBox,
  FiTruck,
  FiGift,
  FiHeart,
  FiSettings,
  FiUsers,
  FiTarget,
  FiFilm,
  FiCreditCard,
} from "react-icons/fi";
import axios from "axios";
import { toast } from "react-toastify";
import logo from "../assets/Logo_G360_White.png";
import "./Sidebar.css";

const API =
  process.env.REACT_APP_API_URL;

function Sidebar({ user }) {

  const token = localStorage.getItem("token");

  const [despachosPendientes,
    setDespachosPendientes] =
    useState(0);

  useEffect(() => {

    const cargarPendientes =
      async () => {

        try {

          const { data } =
            await axios.get(
              `${API}/api/despachos`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );

          const pendientes =
            data.filter(d =>

              [
                "pendiente_guia",
                "pendiente_asignacion",
                "pendiente_proveedor",
                "pendiente_envio",
                "pendiente",
                "creado"
              ].includes(
                (d.estado || "")
                  .toLowerCase()
              )

            ).length;

          setDespachosPendientes(
            pendientes
          );

        } catch (err) {

          console.error(
            "Error cargando despachos:",
            err
          );

        }
      };

    cargarPendientes();

  }, []);

  const verificarAdmin = (e) => {

    if (
      !user ||
      user.rol?.toLowerCase() !== "admin"
    ) {

      e.preventDefault();

      toast.info(
        "¡Lo sentimos! No puedes acceder a este espacio."
      );
    }
  };

  return (
    <aside className="sidebar">
      {/* Logo superior */}
      <div className="sidebar-logo">
        <img src={logo} alt="Logo" />
      </div>

      {/* Menú principal */}
      <nav className="menu">
        <ul>
          <li>
            <NavLink to="/dashboard" className={({ isActive }) => (isActive ? "active" : "")}>
              <FiHome className="icon" /> Dashboard
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/afiliaciones"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <FiUsers className="icon" /> Afiliaciones
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/campaigns"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <FiTarget className="icon" /> Campañas
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/creditos"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <FiCreditCard className="icon" /> Créditos
            </NavLink>
          </li>

          <li>
            <NavLink to="/beneficios" className={({ isActive }) => (isActive ? "active" : "")}>
              <FiHeart className="icon" /> Beneficios
            </NavLink>
          </li>

          <li>
            <NavLink to="/obsequios" className={({ isActive }) => (isActive ? "active" : "")}>
              <FiGift className="icon" /> Obsequios
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/despachos"
              className={({ isActive }) =>
                isActive ? "active" : ""
              }
            >
              <FiTruck className="icon" />
              <span className="sidebar-menu-label">
                Despachos
                {despachosPendientes > 0 && (
                  <span className="sidebar-notification">
                    {despachosPendientes}
                  </span>
                )}
              </span>
            </NavLink>
          </li>        

          <li>
            <NavLink to="/inventario" className={({ isActive }) => (isActive ? "active" : "")}>
              <FiBox className="icon" /> Inventario
            </NavLink>
          </li>

          <li>
            <NavLink to="/boleteria" className={({ isActive }) => (isActive ? "active" : "")}>
              <FiFilm className="icon" /> Boletería
            </NavLink>
          </li>

          <li>
            <NavLink to="/informes" className={({ isActive }) => (isActive ? "active" : "")}>
              <FiBarChart className="icon" /> Informes
            </NavLink>
          </li>

          {/*<li>
            <NavLink to="/payroll" className={({ isActive }) => (isActive ? "active" : "")}>
              <FiSlack className="icon" /> Nóminas
            </NavLink>
          </li>*/}

          {/* ⚙️ Admin Hub */}
          <li>
            <NavLink
              to="/hub"
              onClick={verificarAdmin}  // 👈 validar antes de entrar
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <FiSettings className="icon" /> Hub
            </NavLink>
          </li>
        </ul>
      </nav>

      <div className="sidebar-footer">
        <p>© 2026 G360 | V1.6.5</p>
      </div>
    </aside>
  );
}

export default Sidebar;
